import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 3056B0E6-E30C-4F6D-8647-AC5559FD7DCF
 * name step-backward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/step-backward.svg
 * tags
 */
export const StepBackwardIcon = createSvgIcon(<><path d="M19,5V19H16V5M14,5V19L3,12" /></>, 'StepBackwardIcon');
export default StepBackwardIcon